// Assets
import { CiViewList } from "react-icons/ci";
import { AiOutlineProduct } from "react-icons/ai";
import { GoVideo, GoGear } from "react-icons/go";
import { PiUser, PiUsersThree, PiStudent } from "react-icons/pi";
import { FaRegFilePdf } from "react-icons/fa6";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { BsFileEarmarkBarGraph } from "react-icons/bs";
import { LuGraduationCap } from "react-icons/lu";
import { FaRegBuilding } from "react-icons/fa";

const menuData = [
  {
    categoria: "Ferramentas do Aplicativo",
    botoes: [
      { nome: "Produtos", link: "/produtos", icone: AiOutlineProduct },
      { nome: "Testes", link: "/testes", icone: CiViewList },
      { nome: "Algoritmos", link: "/algoritmos", icone: GoGear },
      { nome: "Devolutivas", link: "/devolutivas", icone: BsFileEarmarkBarGraph },
      { nome: "Vídeos", link: "/videos", icone: GoVideo },
      { nome: "Usuários", link: "/usuarios", icone: PiUser },
    ]
  },
  {
    categoria: "Outras Ferramentas",
    botoes: [
      { nome: "Empresas", link: "/empresas", icone: PiUsersThree },
      { nome: "Participantes", link: "/participantes", icone: PiStudent },
      { nome: "Trilhas Online", link: "/trilhas", icone: LuGraduationCap },
      { nome: "Gerador PDF SSA", link: "/pdfgenerator", icone: FaRegFilePdf },
      { nome: "Institucional", link: "/institucional", icone: FaRegBuilding },
      { nome: "Ajuda", link: "/ajuda", icone: IoMdHelpCircleOutline },
    ]
  }
];

export default menuData;